export enum WysiwygLinkType {
  Questionnaires = 'questionnaires',
  Scheduler = 'scheduler',
  GdprRemove = 'gdpr_remove',
  GdprChange = 'gdpr_change',
  GdprConsentRequest = 'gdpr_consent_request',
  External = 'external',
  IntegrationsKununuApplicantFeedback = 'integrations_kununu_applicant_feedback',
  IntegrationsKununuEmployeeFeedback = 'integrations_kununu_employee_feedback',
}

export enum GDPRLinkToken {
  GdprChange = '[gdpr_request_change_url]',
  GdprRemove = '[gdpr_request_removal_url]',
}

export interface WysiwygLink {
  type: WysiwygLinkType | undefined;
  url: string | undefined;
  label?: string;
  expired?: boolean;
  id?: string;
  target?: 'blank' | 'self';
  name?: string;
  noTokenWarning?: boolean;
  toString: () => string;
}
